const MANDATORY_HEIGHT = 400;

export const getFieldPosition = (ref, placesRef) => {
  if (!ref?.current) return;

  const { bottom, top } = ref.current.getBoundingClientRect();
  const spaceAbove = top;
  const spaceBelow = window.innerHeight - bottom;
  const mandatoryHeight = placesRef?.current?.getBoundingClientRect()?.height || MANDATORY_HEIGHT;

  return spaceAbove >= mandatoryHeight && spaceBelow < mandatoryHeight ? { top: true } : { bottom: true };
};
